import { IconHeart, IconHeartFilled } from '@tabler/icons-react'

export type MyNaviWishButtonProps = {
  isWished: boolean
  onClick: () => void
}

export const MyNaviWishButton = ({ isWished, onClick }: MyNaviWishButtonProps) => {
  return (
    <button
      type="button"
      aria-label={isWished ? '行きたいを解除' : '行きたいに追加'}
      aria-pressed={isWished}
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        width: '83px',
        height: '18px',
        backgroundColor: isWished ? '#E30613' : 'white',
        border: '1px solid #E30613',
        borderRadius: '5px',
        paddingLeft: '8px',
        paddingRight: '4px',
        cursor: 'pointer',
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      {isWished ? <IconHeartFilled size={12} color="white" /> : <IconHeart size={12} color="#E30613" />}
      <span
        style={{
          fontSize: '10px',
          color: isWished ? 'white' : '#E30613',
          fontFamily: "'BIZ UDPGothic', sans-serif",
          whiteSpace: 'nowrap',
          lineHeight: 1,
        }}
      >
        行きたい
      </span>
    </button>
  )
}
